<template>
  <v-container>
    <v-row>
      <v-col>
        <p class="text-h5 mb-3">About</p>
        <p class="text-body-1">
          The Main Road is the group of companies which import and export the vehicles. Our basic approach is the
          removal of barriers in vehicle trade between countries. No matter what country you are from and where the
          interested car is. If you find this car on our website, with the help of group of companies “Main Road” the
          purchase will be easy and safe.<br/>
          The group of companies “Main Road” primarily focuses on the final purchaser of vehicle, thus blurs the
          boundaries between countries in the process of buying. Also we assign the special role to the Sellers and
          Resellers of vehicles. For them we are developing the programs of Partnership and Franchising.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          class="pb-0"
          cols="12"
      >
        <p class="text-h5">Contacts</p>
      </v-col>
      <v-col>
        <p class="text-h6">Sales department</p>
        <p class="text-caption">Email</p>
        <v-btn
            class="text-none"
            prepend-icon="mdi-email"
            variant="text"
            href="mailto:sales@mainroad.trade"
        >
          sales@mainroad.trade
        </v-btn>
        <p class="text-caption mt-3">Phone</p>
        <v-btn
            class="text-none"
            prepend-icon="mdi-phone"
            variant="text"
            href="tel:+821035854748"
        >
          +82-10-3585-4748
        </v-btn>
      </v-col>
      <v-col>
        <p class="text-h6">Social networks</p>
        <v-btn
            class="mb-3"
            prepend-icon="mdi-whatsapp"
            text="WhatsApp"
            color="green"
            href="https://chat.whatsapp.com/BMNOrm3LCxnCRAIDMFxVAF"
        />
        <br/>
        <v-btn
            class="mb-3"
            prepend-icon="mdi-instagram"
            text="Instagram"
            color="purple-darken-2"
            href="https://www.instagram.com/mainroad.trade/"
        />
        <br/>
        <v-btn
            class="mb-3"
            prepend-icon="mdi-facebook"
            text="Facebook"
            color="blue-darken-2"
            href="https://www.facebook.com/mainroad.trade"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row class="pb-4">
          <p class="text-h5">Our team</p>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" v-for="(manager, index) in managers" :key="index">
            <v-row>
              <v-col cols="3" md="3" class="d-flex justify-center align-center">
                <v-avatar
                    :size="$vuetify.display.mdAndUp ? 200 : 120"
                    rounded="0"
                >
                  <v-img
                      :src="manager.photo"
                  />
                </v-avatar>
              </v-col>
              <v-col cols="9" md="9" align-self="center">
                <p class="text-h6 ml-3">{{ manager.name }}</p>
                <p class="text-subtitle-1 ml-3">Speaks: {{ manager.languages.join(", ") }}</p>
                <v-row :no-gutters="true">
                  <v-btn
                      class="text-none"
                      prepend-icon="mdi-phone"
                      variant="text"
                      href="tel:{{ manager.phone }}"
                  >
                    {{ manager.phonePlaceholder }}
                  </v-btn>
                  <v-btn
                      v-if="manager.email !== null"
                      class="text-none"
                      prepend-icon="mdi-email"
                      variant="text"
                      href="mailto:{{ manager.email }}"
                  >
                    {{ manager.email }}
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="pt-5">
      <v-col cols="12">
        <p class="text-h5">Our S. Korean branch</p>
      </v-col>
      <v-col cols="12">
        <p class="text-body">
          South Korea, Incheon, Yeonsu-Gu, Songdomirae-Ro, Building 3, Room 711
        </p>
        <iframe
            :width="$vuetify.display.mdAndUp ? 900 : 350"
            :height="$vuetify.display.mdAndUp ? 650 : 275"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3170.8146458603546!2d126.6442375779123!3d37.37056247209024!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b77a44e931a15%3A0xe0500eab9ece126f!2zOUpDVys2UCwgWWVvbnN1LWd1LCBJbmNoZW9uLCDQrtC20L3QsNGPINCa0L7RgNC10Y8!5e0!3m2!1sru!2sru!4v1698761678996!5m2!1sen!2sen"
            frameborder="0"
            style="border:0;"
            allowfullscreen=""
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p class="text-h5 mb-3">Company registration</p>
        <v-row
            justify="center"
            justify-md="start"
            no-gutters
        >
          <v-img
              src="@/assets/company_certificate_1.jpg"
              max-width="350"
          />
          <v-img
              src="@/assets/company_certificate_2.jpg"
              max-width="350"
          />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {tr} from "vuetify/locale";

export default {
  name: "AboutView",
  computed: {
    tr() {
      return tr
    }
  },
  data: () => ({
    managers: [
      {
        photo: require("@/assets/managers/kirill-ligai.png"),
        name: "Kirill Ligai",
        languages: ["english", "korean"],
        phone: "+821080731013",
        phonePlaceholder: "+82-10-8073-1013",
        email: null
      },
      {
        photo: require("@/assets/managers/kanybek-orozbai.png"),
        name: "Kanybek Orozbai uulu",
        languages: ["english", "korean", "kyrgyz"],
        phone: "+821079269317",
        phonePlaceholder: "+82-10-7926-9317",
        email: "kanybekorozbaiuulu@gmail.com"
      },
    ]
  })
}
</script>

<style scoped>

</style>